const EntityFinderDialogHtml = `<div>
  <div *ngIf="isPageReady" id="entityFinderDialog" class="flex flex-col min-h-0 entity-finder-container" [ngStyle]="{'width': initParams.width, 'height': initParams.height}">
    <div class="grow min-h-0 overflow-hidden">
      <div class="w-full h-full">
        <prox-ag-grid gridId="entityFinderGrid" [gridOptions]="gridOptions" [hasColSizeButtons]="initParams.hasColSizeButtons ?? true"></prox-ag-grid>
      </div>
    </div>
    <div class="flex mt-4 flex-shrink-0">
      <div class="mr-2">
        <button (click)="onOk()" [disabled]="!selectedEntity" pButton type="button" label="Ok" icon="pi pi-check" class="p-button-raised"></button>
      </div>

      <div class="pr-2">
        <button (click)="onCancel()" pButton type="button" icon="pi pi-times" label="Cancel"
          class="p-button-raised"></button>
      </div>

      <div *ngIf=" initParams.showClear" class="pl-4">
        <button (click)="onClear()" pButton type="button" icon="fa-regular fa-eraser" label="Clear"
          class="p-button-raised"></button>
      </div>

    </div>
  </div>
</div>
`;
export default EntityFinderDialogHtml;
